<template>
  <div class="transaction-statistics">
    <!-- 统计卡片 -->
    <div class="statistics-cards">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon" style="background: #409EFF;">
              <i class="el-icon-money"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">¥{{ statistics.totalRecharge }}</div>
              <div class="stat-label">总充值金额</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon" style="background: #67C23A;">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ statistics.totalSmsRecharge }}</div>
              <div class="stat-label">短信充值次数</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon" style="background: #E6A23C;">
              <i class="el-icon-wallet"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">¥{{ statistics.totalSmsAmount }}</div>
              <div class="stat-label">短信充值金额</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon" style="background: #F56C6C;">
              <i class="el-icon-coin"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">¥{{ statistics.totalBalanceAmount }}</div>
              <div class="stat-label">余额充值金额</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 筛选条件 -->
    <div class="filter-container">
      <el-form :model="queryParams" inline>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="handleDateChange"
          ></el-date-picker>
        </el-form-item>
        
        <el-form-item label="订单类型">
          <el-select v-model="queryParams.orderType" placeholder="请选择订单类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="余额充值" value="balance"></el-option>
            <el-option label="短信充值" value="sms"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="支付状态">
          <el-select v-model="queryParams.payStatus" placeholder="请选择支付状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="已支付" value="20"></el-option>
            <el-option label="未支付" value="10"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <!-- <el-button type="success" @click="handleExport">导出</el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <!-- 统计图表 -->
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="20">
          <div class="chart-card">
            <div class="chart-title">充值趋势</div>
            <div id="rechargeTrendChart" style="height: 300px;"></div>
          </div>
        </el-col>
  
      </el-row>
    </div>

    <!-- 订单列表 -->
    <div class="table-container">
      <el-table
        :data="orderList"
        v-loading="loading"
        border
        style="width: 100%"
      >
        <el-table-column prop="order_no" label="订单号" min-width="180"></el-table-column>
        <el-table-column prop="order_type" label="订单类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.order_type === 'balance' ? 'primary' : 'success'">
              {{ scope.row.order_type === 'balance' ? '余额充值' : '短信充值' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pay_price" label="支付金额" width="120">
          <template slot-scope="scope">
            ¥{{ scope.row.pay_price }}
          </template>
        </el-table-column>
        <el-table-column prop="real_money" label="实到金额" width="120">
          <template slot-scope="scope">
            ¥{{ scope.row.real_money }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="give_money" label="赠送金额" width="120">
          <template slot-scope="scope">
            ¥{{ scope.row.give_money || 0 }}
          </template>
        </el-table-column> -->
        <el-table-column prop="pay_status" label="支付状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.pay_status === 1 ? 'success' : 'danger'">
              {{ scope.row.pay_status === 1 ? '已支付' : '未支付' }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="pay_time" label="支付时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.pay_time || '-' }}
          </template>
        </el-table-column> -->
        <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import StatisticsApi from '@/api/statistics.js';
export default {
  name: 'TransactionStatistics',
  data() {
    return {
      // 查询参数
      queryParams: {
        startDate: '',
        endDate: '',
        orderType: '',
        payStatus: '',
        page: 1,
        size: 10
      },
      dateRange: [],
      
      // 统计数据
      statistics: {
        totalRecharge: 0,
        totalSmsRecharge: 0,
        totalSmsAmount: 0,
        totalBalanceAmount: 0
      },
      
      // 订单列表
      orderList: [],
      total: 0,
      loading: false,
      
      // 图表实例
      trendChart: null,
      typeChart: null
    };
  },
  
  mounted() {
    this.initData();
    this.initCharts();
  },
  
  beforeDestroy() {
    if (this.trendChart) {
      this.trendChart.dispose();
    }
    if (this.typeChart) {
      this.typeChart.dispose();
    }
  },
  
  methods: {
    // 初始化数据
    async initData() {
      await this.getStatistics();
      await this.getOrderList();
       await this.getRechargeTrend();
    },
    
    // 获取统计数据
    async getStatistics() {
      try {
        // 传递查询参数
        const params = {
          startDate: this.queryParams.startDate,
          endDate: this.queryParams.endDate
        };
        StatisticsApi.statistics(params).then((res) => {
          if (res.code === 1) {
            this.statistics = res.data;
          }
        });
      } catch (error) {
        console.error('获取统计数据失败:', error);
        this.$message.error('获取统计数据失败');
      }
    },
    
    // 获取订单列表
    async getOrderList() {
      this.loading = true;
      try {
        // 传递所有查询参数
        StatisticsApi.orders(this.queryParams).then((res) => {
          if (res.code === 1) {
            this.orderList = res.data.list;
            this.total = res.data.total;
          }
        });
      } catch (error) {
        console.error('获取订单列表失败:', error);
        this.$message.error('获取订单列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 初始化图表
    initCharts() {
      this.$nextTick(() => {
        this.initTrendChart();
        this.initTypeChart();
      });
    },
    
    // 初始化趋势图表
    initTrendChart() {
      const chartDom = document.getElementById('rechargeTrendChart');
      if (!chartDom) return;
      
      this.trendChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['余额充值', '短信充值']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [] // 从接口获取数据后更新
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '余额充值',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '短信充值',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      };
      this.trendChart.setOption(option);
    },

    // 获取充值趋势数据
async getRechargeTrend() {
  try {
    const params = {
      startDate: this.queryParams.startDate,
      endDate: this.queryParams.endDate
    };
    
    StatisticsApi.rechargeTrend(params).then((res) => {
      if (res.code === 1) {
        this.updateTrendChart(res.data);
      }
    });
  } catch (error) {
    console.error('获取充值趋势失败:', error);
    this.$message.error('获取充值趋势失败');
  }
},

// 更新趋势图表
updateTrendChart(chartData) {
  if (!this.trendChart) return;
  
  const option = {
    tooltip: {
      trigger: 'axis',
      formatter: function(params) {
        let result = `${params[0].axisValue}<br>`;
        params.forEach(param => {
          result += `${param.seriesName}: ¥${param.value}<br>`;
        });
        return result;
      }
    },
    legend: {
      data: ['余额充值', '短信充值']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: chartData.dates
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '¥{value}'
      }
    },
    series: [
      {
        name: '余额充值',
        type: 'line',
        smooth: true,
        data: chartData.balanceData,
        itemStyle: {
          color: '#409EFF'
        }
      },
      {
        name: '短信充值',
        type: 'line',
        smooth: true,
        data: chartData.smsData,
        itemStyle: {
          color: '#67C23A'
        }
      }
    ]
  };
  
  this.trendChart.setOption(option);
},
    
    // 初始化类型分布图表
    initTypeChart() {
      const chartDom = document.getElementById('rechargeTypeChart');
      if (!chartDom) return;
      
      this.typeChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '充值类型',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 0, name: '余额充值' },
              { value: 0, name: '短信充值' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      this.typeChart.setOption(option);
    },
    
    // 日期范围改变
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.queryParams.startDate = dateRange[0];
        this.queryParams.endDate = dateRange[1];
      } else {
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
      }
    },
    
    // 搜索
    handleSearch() {
      this.queryParams.page = 1;
      this.initData();
    },
    
    // 重置
    handleReset() {
      this.queryParams = {
        startDate: '',
        endDate: '',
        orderType: '',
        payStatus: '',
        page: 1,
        size: 10
      };
      this.dateRange = [];
      this.initData();
    },
    
    // 导出
    handleExport() {
      // 导出逻辑
      this.$message.info('导出功能开发中...');
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.queryParams.size = size;
      this.queryParams.page = 1; // 重置到第一页
      this.getOrderList();
    },
    
    // 当前页改变
    handleCurrentChange(page) {
      this.queryParams.page = page;
      this.getOrderList();
    }
  }
};
</script>

<style scoped>
.transaction-statistics {
  padding: 20px;
}

.statistics-cards {
  margin-bottom: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

.filter-container {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.chart-container {
  margin-bottom: 20px;
}

.chart-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.chart-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.table-container {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/report/transaction_statistics.vue